<template>
    <!-- Mobile -->
    <mobile-card-slider
    v-if="getMobileAppState"
    :dashboardWidget="dashboardWidget"
    :dashboardWidgetAnchor="dashboardWidgetAnchor"
    :selectedCardId="selectedCardId"
    :cardsList="cardsList"
    :hideBalance="hideBalance"
    @clicked="emit('clicked', $event)"/>
    <!-- Web -->
    <web-card-slider
    v-else
    :dashboardWidget="dashboardWidget"
    :dashboardWidgetAnchor="dashboardWidgetAnchor"
    :selectedCardId="selectedCardId"
    :cardsList="cardsList"
    :hideBalance="hideBalance"
    @showNewCardModal="showNewCardModal = true"
    @clicked="emit('clicked', $event)"/>
    <!-- New Card Modal -->
    <new-card-modal
    v-if="showNewCardModal"
    :dashboardWidget="dashboardWidget || dashboardWidgetAnchor"
    @hideMe="showNewCardModal = false"/>
</template>

<script setup>
import MobileCardSlider from '@/components/generic/sliders/bankCards/Mobile'
import WebCardSlider from '@/components/generic/sliders/bankCards/Web'
import NewCardModal from '@/components/features/cards/consult/NewCardModal'
/* Vue */
import { ref } from 'vue'
/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['clicked'])

/* mapGetters */
const { getMobileAppState } = mapGetters()

/* Props
@dashboardWidget {Boolean} - prop to apply logics for this to be used on dashboardWidget
@dashboardWidgetAnchor {Boolean} - prop to apply logics for this to be used on dashboardWidget Ancgor Variant
@selectedCardId {Number} - card id of selected card
@cardList {Array}
@hideBalance {Boolean} - flag to hide/show image with balances
*/
const props = defineProps({
	dashboardWidget: Boolean,
	dashboardWidgetAnchor: Boolean,
	selectedCardId: Number,
	cardsList: Array,
    hideBalance: Boolean
})

const showNewCardModal = ref(false)
</script>

<style lang="scss" scoped>
</style>
